<div
	class="tw-shrink-0 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-font-semibold"
	[class.tw-w-8]="size === 'sm'"
	[class.tw-h-8]="size === 'sm'"
	[class.tw-text-xs]="size === 'sm'"
	[class.tw-w-10]="size === 'md'"
	[class.tw-h-10]="size === 'md'"
	[class.tw-text-sm]="size === 'md'"
	[class.tw-w-12]="size === 'lg'"
	[class.tw-h-12]="size === 'lg'"
	[class.tw-text-base]="size === 'lg'"
	[class.tw-w-20]="size === 'xl'"
	[class.tw-h-20]="size === 'xl'"
	[class.tw-text-2xl]="size === 'xl'"
	[style.background-color]="getColors().backgroundColor"
	[style.color]="getColors().color">
	{{ getDisplayInitials() }}
</div>
